import HomeHeaderProfile from "@/components/HomeHeader/indexProfile";
import MyNavLink from "@/components/MyNavLink";
import { LocalConfig } from "@/config";
import { PersistContext } from "@/data/PersistProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { ChannelRemind } from "@/utils/UrlHelper";
import React from "react";
import { Button, Cell, Image } from "react-vant";
import style from "./style.less";
import DownloadFloatBall from "@/components/DownloadFloatBall";
import { FromInstalled } from "@/utils/BroswerHelper";
const Profile = () => {
  const { getPersist, setPersist } = React.useContext(PersistContext);
  const [downloadFloatBall, setDownloadFloatBall] = React.useState(false);
  const history = useEnhancedHistory();
  const onLogout = () => {
    console.log("onLogoutClick");
    setPersist("user_info", null);
    history.replace(ChannelRemind("./home"));
  };
  const onLogin = () => {
    console.log("onLoginClick");
    history.replace(ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1&"}`));
  };

  React.useEffect(() => {
    //下载悬浮球
    if (!FromInstalled) {
      setDownloadFloatBall(true);
    }
  }, []);

  const userInfo = getPersist("user_info");
  console.log("userInfo", userInfo);

  return (
    <div class={style.page_container}>
      <HomeHeaderProfile />
      <div class={style.profile_container}>
        <div class={style.profile_middle}>
          <div class={style.profile_middle_link}>
            {userInfo ? (
              <div class={style.profile_middle_link_top}>
                <div class={style.profile_middle_link_top_title}>
                  <div style={{ marginLeft: "5rem", display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <img src={require("@/assets/images/home/wallet.png").default} style={{ width: "1.3135rem" }} />
                  </div>
                  <div style={{ display: "flex", marginRight: "5.5rem", marginLeft: "0.3rem" }}>
                    My Wallet({LocalConfig.currencyCode})
                  </div>
                </div>
                <div class={style.profile_middle_link_top_num}>
                  <span>{(userInfo.money.coin / 100).toLocaleString("en-US", { maximumFractionDigits: 2 })}</span>
                </div>
              </div>
            ) : (
              <div class={style.profile_middle_link_top}>
                <div class={style.profile_middle_link_top_hint}>Please log in...</div>
              </div>
            )}

            <div class={style.profile_middle_link_bottom}>
              <MyNavLink to="/withdraw">
                <Button
                  type="primary"
                  style={{
                    float: "left",
                    paddingLeft: "0.5rem",
                    width: "5.64rem",
                    height: "1.78rem",
                    marginLeft: "2rem",
                    borderRadius: "1.2rem",
                    fontSize: "0.93rem",
                    backgroundColor: "transparent",
                    border: "2px solid #ffffff",
                  }}
                >
                  Withdraw
                </Button>
              </MyNavLink>
              <MyNavLink to="/deposit">
                <Button
                  type="primary"
                  style={{
                    float: "right",
                    width: "5.64rem",
                    height: "1.78rem",
                    marginRight: "2rem",
                    borderRadius: "1.2rem",
                    fontSize: "0.93rem",
                    backgroundColor: "transparent",
                    border: "2px solid #ffffff",
                  }}
                >
                  Deposit
                </Button>
              </MyNavLink>
            </div>
          </div>
          <div class={style.profile_coins_lucky}>
            <div class={style.profile_coins}>
              <img
                src={require("@/assets/images/home/silver.png").default}
                style={{
                  width: "1.67rem",
                  height: "1.67rem",
                  marginLeft: "0.8rem",
                  marginTop: "0.43rem",
                }}
              />
              <div class={style.profile_coins_info}>
                Coins:
                <span>
                  {userInfo
                    ? (userInfo.money.silver_coin ? userInfo.money.silver_coin / 100 : 0 / 100).toLocaleString(
                      "en-US",
                      {
                        maximumFractionDigits: 2,
                      }
                    )
                    : ""}
                </span>
              </div>
            </div>
            <MyNavLink to="/luckyDraw">
              <div class={style.profile_lucky_wheel}>
                <span>Lucky Wheel</span>
              </div>
            </MyNavLink>
          </div>
          <div class={style.profile_middle_cell}>
            <MyNavLink to="/depositLog">
              <div
                style={{
                  backgroundColor: "#10473f",
                  borderTopLeftRadius: "0.7rem",
                  borderTopRightRadius: "0.7rem",
                  paddingLeft: "0.45rem",
                  paddingRight: "0.45rem",
                }}
              >
                <Cell
                  icon={
                    <Image width={"1.8rem"} height={"1.7rem"} src={require("@/assets/images/profile/5.png").default} />
                  }
                  style={{
                    borderBottom: "0.17rem solid #415e5a",
                    paddingLeft: "0.55rem",
                    backgroundColor: "#10473f",
                    color: "#fff",
                    fontSize: "1rem",
                    borderTopLeftRadius: "0.7rem",
                    borderTopRightRadius: "0.7rem",
                  }}
                  titleStyle={{ marginTop: "0.3rem" }}
                  title="Deposit Records"
                  isLink
                  rightIcon={
                    <Image
                      width={"1.8rem"}
                      height={"1.8rem"}
                      style={{ marginRight: "-1rem" }}
                      src={require("@/assets/images/profile/7.png").default}
                    />
                  }
                />
              </div>
            </MyNavLink>
            <MyNavLink to="/withdrawLog">
              <div style={{ backgroundColor: "#10473f", paddingLeft: "0.45rem", paddingRight: "0.45rem" }}>
                <Cell
                  icon={
                    <Image width={"1.8rem"} height={"1.8rem"} src={require("@/assets/images/profile/4.png").default} />
                  }
                  titleStyle={{ marginTop: "0.3rem" }}
                  style={{
                    borderBottom: "0.17rem solid #415e5a",
                    paddingLeft: "0.55rem",
                    backgroundColor: "#10473f",
                    color: "#fff",
                    fontSize: "1rem",
                  }}
                  title="Withdraw Records"
                  isLink
                  rightIcon={
                    <Image
                      width={"1.8rem"}
                      height={"1.8rem"}
                      style={{ marginRight: "-1rem" }}
                      src={require("@/assets/images/profile/7.png").default}
                    />
                  }
                />
              </div>
            </MyNavLink>
            <MyNavLink to="/about">
              <div style={{ backgroundColor: "#10473f", paddingLeft: "0.45rem", paddingRight: "0.45rem" }}>
                <Cell
                  icon={
                    <Image width={"1.8rem"} height={"1.8rem"} src={require("@/assets/images/profile/3.png").default} />
                  }
                  titleStyle={{ marginTop: "0.3rem" }}
                  style={{
                    borderBottom: "0.17rem solid #415e5a",
                    paddingLeft: "0.55rem",
                    backgroundColor: "#10473f",
                    color: "#fff",
                    fontSize: "1rem",
                  }}
                  title="About Us"
                  isLink
                  rightIcon={
                    <Image
                      width={"1.8rem"}
                      height={"1.8rem"}
                      style={{ marginRight: "-1rem" }}
                      src={require("@/assets/images/profile/7.png").default}
                    />
                  }
                />
              </div>
            </MyNavLink>
            <MyNavLink to="/help">
              <div style={{ backgroundColor: "#10473f", paddingLeft: "0.45rem", paddingRight: "0.45rem" }}>
                <Cell
                  icon={
                    <Image width={"1.8rem"} height={"1.8rem"} src={require("@/assets/images/profile/2.png").default} />
                  }
                  titleStyle={{ marginTop: "0.3rem" }}
                  style={{
                    borderBottom: "0.17rem solid #415e5a",
                    paddingLeft: "0.55rem",
                    backgroundColor: "#10473f",
                    color: "#fff",
                    fontSize: "1rem",
                  }}
                  title="Help"
                  isLink
                  rightIcon={
                    <Image
                      width={"1.8rem"}
                      height={"1.8rem"}
                      style={{ marginRight: "-1rem" }}
                      src={require("@/assets/images/profile/7.png").default}
                    />
                  }
                />
              </div>
            </MyNavLink>
            <MyNavLink to="/contact">
              <div style={{ backgroundColor: "#10473f", paddingLeft: "0.45rem", paddingRight: "0.45rem" }}>
                <Cell
                  icon={
                    <Image width={"1.8rem"} height={"1.8rem"} src={require("@/assets/images/profile/1.png").default} />
                  }
                  titleStyle={{ marginTop: "0.3rem" }}
                  style={{
                    borderBottom: "0.17rem solid #415e5a",
                    paddingLeft: "0.55rem",
                    backgroundColor: "#10473f",
                    color: "#fff",
                    fontSize: "1rem",
                  }}
                  title="Contact Us"
                  isLink
                  rightIcon={
                    <Image
                      width={"1.8rem"}
                      height={"1.8rem"}
                      style={{ marginRight: "-1rem" }}
                      src={require("@/assets/images/profile/7.png").default}
                    />
                  }
                />
              </div>
            </MyNavLink>
            <MyNavLink to="/invite">
              <div
                style={{
                  backgroundColor: "#10473f",
                  borderBottomLeftRadius: "0.7rem",
                  borderBottomRightRadius: "0.7rem",
                  paddingLeft: "0.45rem",
                  paddingRight: "0.45rem",
                }}
              >
                <Cell
                  icon={
                    <Image width={"1.8rem"} height={"1.8rem"} src={require("@/assets/images/profile/6.png").default} />
                  }
                  titleStyle={{ marginTop: "0.3rem" }}
                  style={{
                    backgroundColor: "#10473f",
                    paddingLeft: "0.55rem",
                    color: "#fff",
                    fontSize: "1rem",
                    borderBottomLeftRadius: "0.7rem",
                    borderBottomRightRadius: "0.7rem",
                  }}
                  title="Promotions"
                  isLink
                  rightIcon={
                    <Image
                      width={"1.8rem"}
                      height={"1.8rem"}
                      style={{ marginRight: "-1rem" }}
                      src={require("@/assets/images/profile/7.png").default}
                    />
                  }
                />
              </div>
            </MyNavLink>
          </div>
        </div>
        <div
          class={style.logout_btn}
          onClick={() => {
            userInfo ? onLogout() : onLogin();
          }}
        >
          {userInfo ? "Logout" : getPersist("last_phone") ? "Login" : "Register"}
        </div>
      </div>
      <DownloadFloatBall floatBall={downloadFloatBall} onClose={() => setDownloadFloatBall(false)} />
    </div>
  );
};

export default Profile;
